import React, {PureComponent} from 'react';
import Check from 'react-feather/dist/icons/check.js';
import PropTypes from 'prop-types';

import './StepIndicatorIcon.scss';

export default class StepIndicatorIcon extends PureComponent {
  static propTypes = {
    isActive: PropTypes.bool,
    isDone: PropTypes.bool,
    stepNumber: PropTypes.number.isRequired,
  };

  static defaultProps = {
    isActive: false,
    isDone: false,
  };

  render() {
    const classNames = ['step-indicator-icon d-flex align-items-center'];
    if (this.props.isActive) {
      classNames.push('active');
    }

    if (this.props.isDone) {
      classNames.push('done');
    }

    return <span className={classNames.join(' ')}>
      {this.props.isDone ? <Check className="mx-auto"/> : ''}
      {!this.props.isDone ? <span className="mx-auto">{this.props.stepNumber}</span> : ''}
    </span>;
  }
}
